export function isPromise(value: unknown): value is Promise<unknown> {
  return Boolean(
    typeof value === 'object' &&
      value &&
      typeof (value as Record<string, unknown>).then === 'function',
  );
}
